export type DemoOption = {
  id: string;
  label: string;
  isCorrect: boolean;
};

export type DemoQuestion = {
  eyebrow: string;
  title: string;
  body: string;
  code: string;
  prompt: string;
  options: DemoOption[];
  hint: {
    label: string;
    lines: string[];
  };
  feedback: {
    correct: {
      lead: string;
      followUp: string;
    };
    incorrect: {
      lead: string;
      followUp: string;
    };
  };
};

export const DEMO_QUESTION: DemoQuestion = {
  eyebrow: 'Sample practice question · JavaScript · Junior level',
  title: 'What does this function return?',
  body: "A teammate wrote this. It looks fine. Copilot autocompleted it. But something's off.",
  code: `function total(items) {
  items.forEach(i => {
    return i.price;
  });
}

console.log(total([{ price: 10 }, { price: 20 }]));
// → ?`,
  prompt: 'Pick what the console prints:',
  options: [
    {
      id: 'a',
      label: '30: the prices get summed',
      isCorrect: false,
    },
    {
      id: 'b',
      label: "undefined: forEach doesn't return values",
      isCorrect: true,
    },
    {
      id: 'c',
      label: 'SyntaxError: return inside a loop is invalid',
      isCorrect: false,
    },
  ],
  hint: {
    label: 'Prepzio says: think through it, not around it:',
    lines: [
      'What does Array.forEach() return according to MDN?',
      'Try swapping forEach for map in your head. What changes?',
      'The return inside the callback goes back to… where?',
    ],
  },
  feedback: {
    correct: {
      lead: 'Nice catch.',
      followUp:
        "In the real app, the next step is: explain why forEach doesn't return — in your own words. Understanding starts there.",
    },
    incorrect: {
      lead: 'Most juniors miss this — because Copilot misses it too.',
      followUp:
        'Prepzio would not show the answer. It would ask: "What do you think forEach actually returns?" and walk you from there.',
    },
  },
};

export const DEMO_RUBRIC_ROWS = [
  { label: 'Independent attempt', done: true },
  { label: 'Accepted coaching hint', done: true },
  { label: 'Explained the answer', done: false, locked: true },
  { label: 'Transfer question', done: false, locked: true },
] as const;
